<!--
   Created by qing on 2020/12/19
   Des: 评论展示内容
-->
<template>
  <div class="comment-container-component">
    <div class="title">
      评论({{commentLength}})
    </div>
    <template v-if="commentList && commentList.length">
      <div
        class="comment-item"
        v-for="(item, idx) in commentList"
        v-if="!item.deleteFlag"
        :key="item.commentId">
        <div class="user-img">
          <van-image
            round
            style="width: 30px; height: 30px;"
            :src="item.headImage"
          ></van-image>
        </div>
        <div class="comment-info">
          <div class="top">
            <div class="user-info">
              <div>
                {{item.userName}}
              </div>
              <div>
                {{actionFormatTime(item.commentTime)}}
              </div>
            </div>
            <div class="comment-handle">
              <div
                class="handle-button"
                @click.stop.prevent.left="replyComment(item)">
                回复
              </div>
              <div
                v-if="item.userId === $store.getters.userId"
                class="handle-button"
                @click.stop.prevent.left="editComment(item)">
                编辑
              </div>
              <div
                v-if="item.userId === $store.getters.userId"
                class="handle-button"
                style="color: red;"
                @click.stop.prevent.left="deleteComment(item, idx)">
                删除
              </div>
            </div>
          </div>
          <div
            class="reply-container"
            v-if="fetchSourceComment(item.replyId)"
            @click.stop="onClickComment(item)">
            <div class="line"></div>
            <div class="reply-content">
              回复&nbsp;&nbsp;{{fetchSourceComment(item.replyId).userName}}:&nbsp;{{fetchSourceContent(item.replyId)}}
            </div>
          </div>

          <div class="comment-detail">
            <div v-if="item.content" class="comment-content ql-editor" v-html="item.content"></div>

            <ul class="file__list">
              <li v-for="(file, idx) in item.attachmentList">
                <div class="file__icon">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                  </svg>
                </div>
                <div class="file__info">
                  <div class="file__info-name">
                    {{file.fileName}}
                  </div>
                  <div class="file__info-bottom">

                    <div class="file__info-size">
                      {{file.fileSize}}KB
                    </div>
                    <div class="file__info-handle">
                      <div
                        class="handle-button"
                        @click.stop.prevent.left="previewFile(item.attachmentList, file)">
                        预览
                      </div>
                      <div class="divider"></div>
                      <div
                        class="handle-button"
                        @click.stop.prevent.left="downloadFile(file)">
                        下载
                      </div>
                      <div class="divider"></div>
                      <div
                        v-if="item.userId === $store.getters.userId"
                        class="handle-button"
                        @click="openFileAccessRecords(file.fileUrl)">
                        访问记录
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="empty-comment">
      暂无评论
    </div>

    <!--访问记录-->
    <file-access-records
      ref="fileAccessRecords"
      :stackList="stackList"
    ></file-access-records>

    <file-preview-popup
      ref="filePreviewPopup"
      :stackList="stackList"
    ></file-preview-popup>
    <gallery :images="previewData" :index="index" @close="index = null"></gallery>
  </div>
</template>

<script>
  import {accurateFormatDate, fileType2FileImage, getSimpleText} from "../../../assets/js/Untis";
  import FileAccessRecords from "./FileAccessRecords";
  import FilePreviewPopup from "./FilePreviewPopup";
  import VueGallery from 'vue-gallery';

  export default {
    props: {
      commentList: {
       type: Array,
       default: () => []
      },
      stackList: {
        type: Array,
        default: () => []
      }
    },
    components:{FileAccessRecords, FilePreviewPopup,
      'gallery': VueGallery},
    data() {
      return {
        downloadEle: null,
        index: null,
        previewData: []
      }
    },
    created() {
      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')
    },
    computed: {
      commentLength() {
        let index = 0
        this.commentList.forEach(comment => {
          if (!comment.deleteFlag) {
            index++
          }
        })
        return index
      }
    },
    methods: {
      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },

      // 下载文件
      downloadFile(file) {
        this.downloadEle.setAttribute('download', file.fileName)
        this.downloadEle.setAttribute('href', `${file.fileUrl}?userId=${this.$store.state.userInfo.userId}`)
        this.downloadEle.click()
      },
      previewFile(val, file) {

        if (['#icon-WAV','#icon-mp', '#icon-tupian'].includes(fileType2FileImage(file.fileType))) {
          this.previewData = val ? val.map(file => {
            return {
              id: file.id,
              title: file.fileName,
              type: file.fileType,
              href: file.fileUrl,
              poster: '',
              thumbnail: file.fileUrl
            }
          }).filter(item => ['#icon-WAV','#icon-mp', '#icon-tupian'].includes(fileType2FileImage(item.type))) : []
          this.previewData.forEach((item, idx) => {
            if (item.id === file.id) {
              this.index = idx
            }
          })
          return
        }
        if (this.$refs.filePreviewPopup) {
          this.$refs.filePreviewPopup.open(file, 'MIX_FORM')
        }
      },

      // 获取回复的评论
      fetchSourceComment(commentId) {
        return this.commentList.filter(comment => comment.commentId === commentId)[0]
      },
      // 获取回复的评论的字符串内容
      fetchSourceContent(commentId) {
        const comment = this.fetchSourceComment(commentId)
        if (!comment) {
          return ''
        }
        let content = getSimpleText(comment.content)
        content += comment.content.includes('<img') ? '【图片】' : ''
        content += comment.content.includes('<video') ? '【视频】' : ''
        if (!content) {
          if (comment.attachmentList && comment.attachmentList.length) {
            content = '【附件】'
          }
        }
        return content
      },

      // 点击评论
      onClickComment(item) {
        this.$emit('onClickComment', item)
      },

      // 回复评论
      replyComment(item) {
        this.$emit('replyComment', item)
      },
      // 编辑评论
      editComment(item) {
        this.$emit('editComment', item)
      },
      // 删除评论
      deleteComment(item, idx) {
        this.$dialog.confirm({
          title: '提示',
          message: '删除评论后将无法恢复，是否删除?',
          confirmButtonText: '删除',
        }).then(() => {
          this.$store.dispatch('actionCommentDelete', {
            ...item
          }).then(res => {
            this.$toast.success('删除成功')
            item.deleteFlag = 1
            item.content = `${item.userName}已删除评论`
          }).catch(console.error)

        }).catch(action => {
        })
      },

      openFileAccessRecords(fileUrl) {
        if (this.$refs.fileAccessRecords) {
          this.$refs.fileAccessRecords.open(fileUrl)
        }
      },
    }
  }
</script>

<style lang="less">

  .comment-container-component {
    width: 100%;
    padding: 10px;

    .title {
      font-size: 13px;
      color: #5d616f;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e6e6e6;
    }

    .comment-item {
      width: 100%;
      display: flex;
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px dashed #e6e6e6;

      .user-img {
        width: 40px;

        .el-image {
          border-radius: 50%;
        }
      }

      .comment-info {
        width: calc(100% - 40px);

        .reply-container {
          background-color: #F4F4FA;
          padding: 10px;
          display: flex;
          width: 100%;
          cursor: pointer;

          .line {
            width: 3px;
            height: 12px;
            background-color: #909399;
            margin-right: 10px;
          }

          .reply-content {
            font-size: 12px;
            width: calc(100% - 20px);
            color: #909399;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }
        }

        .top {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .user-info {
            display: flex;

            > div {
              font-size: 12px;
              color: #6d6d6d;
              margin-right: 10px;
            }
          }

          .comment-handle {
            display: flex;
            align-items: center;

            .handle-button {
              margin-right: 10px;
            }
          }
        }

        .comment-detail {

          .comment-content {
            font-size: 12px;
            color: #333;

            img, video {
              max-width: 100%;
            }
          }

          .file__list {

          }
        }
      }
    }

    .empty-comment {
      width: 100%;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #6d6d6d;
    }
  }
</style>